<h1>Dash board</h1>
<div class="app">
      <app-dynamic-form [config]="config" #form="dynamicForm" (submit)="submit($event)">
      </app-dynamic-form>
      {{ form.valid }}
      {{ form.value | json }}
    </div> <br><br>

    <mat-form-field appearance="outline">
      <mat-label>Outline form field</mat-label>
      <input matInput placeholder="Placeholder">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
      <mat-hint>Hint</mat-hint>
    </mat-form-field>



            
